/*! @pentacode/ui v0.1.0 */
import { t as e } from "./css-build-DcREbovZ.js";
import { iconHref as t, onIconSpriteChange as n } from "./elements/icon/sprite-source.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o, nothing as s, svg as c } from "lit";
import { customElement as l, property as u } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/icon/icon.css.js
var d = e(":host{vertical-align:-.375em;block-size:1.5em;inline-size:1.5em;display:inline-block}:host([hidden]){display:none}[part=glyph]{fill:currentColor;block-size:1.25em;inline-size:1.25em;display:block;position:relative;inset-block-start:50%;inset-inline-start:50%;translate:-50% -50%}"), f = class extends a {
	constructor(...e) {
		super(...e), this.label = "";
	}
	static {
		this.styles = [d];
	}
	connectedCallback() {
		super.connectedCallback(), this.unsubscribe = n(() => this.requestUpdate());
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.unsubscribe?.();
	}
	render() {
		let e = !this.label;
		return o`<svg
            part="glyph"
            role=${e ? s : "img"}
            aria-label=${this.label || s}
            aria-hidden=${e ? "true" : s}
        >
            ${this.name ? c`<use href=${t(this.name)}></use>` : s}
        </svg>`;
	}
};
i([u({ reflect: !0 }), r("design:type", Object)], f.prototype, "name", void 0), i([u(), r("design:type", Object)], f.prototype, "label", void 0), f = i([l("ptc-ui-icon")], f);
export { f as t };

//# sourceMappingURL=icon-DW8BBY5W.js.map